<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Total Item"
          :value="convertRp(totalItem)"
          iconClass="ni ni-collection"
          iconBackground="bg-gradient-primary"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Quantity Item"
          :value="(totalBarang)"
          iconClass="ni ni-folder-17"
          iconBackground="bg-gradient-danger"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Total Stock In"
          :value="(totalBarangMasuk)"
          iconClass="ni ni-cloud-download-95"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <card
          title="Total Stock Out"
          :value="(totalBarangKeluar)"
          iconClass="ni ni-cloud-upload-96"
          iconBackground="bg-gradient-warning"
          directionReverse
        ></card>
      </div>
    </div>
    <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/stock-barang?material_code='+search.material_code+'&material_name='+search.material_name+'&specification='+search.specification+'&size='+search.size+'&type='+search.type+'&unit='+search.unit+'&storage_location='+search.storage_location+'&date='+search.date+'&sort_by='+search.sort_by+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a>
    <a class="btn btn-sm btn-info" style="margin-right: 10px;" :href="apiUrl+'print-pdf/stock-barang-hse?material_code='+search.material_code+'&material_name='+search.material_name+'&type='+search.type+'&specification='+search.specification+'&size='+search.size+'&unit='+search.unit+'&storage_location='+search.storage_location+'&date='+search.date+'&sort_by='+search.sort_by+''" target="_BLANK"><i class="fa fa-file-pdf-o fa-sm"></i> Print PDF</a>
    <a class="btn btn-sm btn-warning" style="margin-left: 0px;" :href="apiUrl+'print-pdf/stock-barang-qr-code?material_code='+search.material_code+'&material_name='+search.material_name+'&type='+search.type+'&unit='+search.unit+'&storage_location='+search.storage_location+'&date='+search.date+'&sort_by='+search.sort_by+''" target="_BLANK"><i class="fa fa-qrcode fa-sm"></i> Print QR Code</a>
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-lg-4">
                <div class="card-header pb-0">
                  <h6>Item List</h6>
                </div>
              </div>
              <div class="col-lg-4">
                <input type="text" class="form-control mt-3" placeholder="Search by Item Name" v-model="search.material_name" @keyup="get()">
              </div>
              <div class="col-lg-4 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="danger"
                  size="sm"
                  @click="cutOff()"
                  disabled
                ><i class="fa fa-scissors fa-sm" aria-hidden="true"></i> Cut Off</argon-button>
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">No</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Image</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Item Code</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Item Name</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Specification</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Size</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Unit</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">{{ moment(beginingStockFilter).subtract(1, "month").startOf("month").format('MMMM') }}</th>
                      <th colspan="3" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">{{ moment(beginingStockFilter).subtract("month").startOf("month").format('MMMM') }}</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Min Stock</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Storage Location</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Item Group</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Item Category</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Item Sub Category</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Asset Status</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Created By</th>
                      <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                    </tr>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Stock</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Input</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Output</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">Ending Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #7FFF00; cursor: pointer;' : 'cursor: pointer;' ">
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <img
                          :src="storageUrl+'/image_barang/'+row.image"
                          class="avatar avatar-lg me-1"
                          alt="user1"
                        />
                      </td>
                      <td class="align-middle text-center text-sm">
                        <!-- <router-link :to="/detail-barang/+row.material_code"> -->
                          <span class="badge badge-sm bg-gradient-primary" @click="getStockCard(row.material_code)">{{ row.material_code }}</span>
                        <!-- </router-link> -->
                      </td>
                      <td class="align-middle text-left">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.material_name}}</span>
                      </td>
                      <td class="align-middle text-left">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-left">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.unit}}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ (row.total_begining_stock_count) }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.total_barang_masuk_count }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.total_barang_keluar_count }}</span>
                      </td>
                      <!-- ----------------------- -->
                      <td class="align-middle text-center" v-if="afterStockFilter">
                        <span class="badge badge-sm bg-gradient-success" v-if="row.total_after_stock_count >= row.min_stock">{{ row.total_after_stock_count }}</span>
                        <span class="badge badge-sm bg-gradient-danger" v-if="row.total_after_stock_count < row.min_stock">{{ row.total_after_stock_count }}</span>
                      </td>
                      <td class="align-middle text-center" v-else>
                        <span class="badge badge-sm bg-gradient-success" v-if="row.stock_barang >= row.min_stock">{{ row.stock_barang }}</span>
                        <span class="badge badge-sm bg-gradient-danger" v-if="row.stock_barang < row.min_stock">{{ row.stock_barang }}</span>
                      </td>
                      <!-- ----------------------- -->
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.min_stock }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.storage_location }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_group }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_category }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.item_sub_category }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge badge-sm bg-gradient-warning" v-if="row.type == 'Asset' ">{{ row.type }}</span>
                        <span class="badge badge-sm bg-gradient-secondary" v-if="row.type == 'Non Asset' ">{{ row.type }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ row.created_by }}</span>
                      </td>
                      <td>
                        <i class="fas fa-edit fa-sm" aria-hidden="true" title="Edit data ini" style="cursor: pointer; margin-right: 20px;" @click="edit(row.id)"></i>
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus data ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-left">TOTAL ROWS : {{table.data.length}} </div>
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3" v-if="form.title == 'Edit Data'">Item Code <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Item Code" v-model="dataBarangMasuk.material_code" required @change="cekMaterial()" :disabled="form.title == 'Edit Data'" v-if="form.title == 'Edit Data'">

        <label for="example-text-input" class="form-control-label mt-3">Item Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="dataBarangMasuk.material_name" required >

        <label for="example-text-input" class="form-control-label mt-3">Specification</label>
        <input type="text" class="form-control" placeholder="Specification" v-model="dataBarangMasuk.specification">

        <label for="example-text-input" class="form-control-label mt-3">Size</label>
        <input type="text" class="form-control" placeholder="Size" v-model="dataBarangMasuk.size">

        <label for="example-text-input" class="form-control-label mt-3">Unit <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="dataBarangMasuk.unit">
          <option v-for="(u, k) in tableUom.data" :key="k" :value="u.code">{{ u.name }}</option>
        </select>

        <label for="example-text-input" class="form-control-label mt-3">Ending Stock <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Ending Stock" v-model="dataBarangMasuk.stock_barang">

        <label for="example-text-input" class="form-control-label mt-3">Min Stock </label>
        <input type="number" class="form-control" placeholder="Min Stock" v-model="dataBarangMasuk.min_stock">

        <label for="example-text-input" class="form-control-label mt-3">Storage Location </label>
        <input type="text" class="form-control" placeholder="Storage Location" v-model="dataBarangMasuk.storage_location">

        <label for="example-text-input" class="form-control-label mt-3">Image <span style="color: red;">*</span></label>
        <input type="file" class="form-control" placeholder="Image" @change="filesChange">

        <label for="example-text-input" class="form-control-label mt-3">Item Group <span style="color: red;">*</span></label>
        <multiselect v-model="dataBarangMasuk.item_group" :options="tableItemGroup.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Item Group" label="group_name" track-by="group_name" :preselect-first="true" @keyup="getItemGroup" :custom-label="nameWithGrpCode">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Item Category </label>
        <multiselect v-model="dataBarangMasuk.item_category" :options="tableItemCategory.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Item Category" label="category_name" track-by="category_name" :preselect-first="true" @keyup="getItemCategory" :custom-label="nameWithCatCode">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect> 
        <label for="example-text-input" class="form-control-label mt-3">Item Sub Category </label>
        <multiselect v-model="dataBarangMasuk.item_sub_category" :options="tableItemSubCategory.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Item Sub Category" label="sub_category_name" track-by="sub_category_name" :preselect-first="true" @keyup="getItemSubCategory" :custom-label="nameWithSubCode">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Asset Status <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="dataBarangMasuk.type">
          <option value="Asset">Asset</option>
          <option value="Non Asset">Non Asset</option>
        </select>

        <!-- <label for="example-text-input" class="form-control-label mt-3">Note </label>
        <input type="text" class="form-control" placeholder="Note" v-model="dataBarangMasuk.note" required> -->
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = true">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Item Code</label>
        <input type="text" class="form-control" placeholder="Item Code" v-model="search.material_code">
        <label for="example-text-input" class="form-control-label mt-3">Item Name</label>
        <input type="text" class="form-control" placeholder="Item Name" v-model="search.material_name">
        <label for="example-text-input" class="form-control-label mt-3">Specification</label>
        <input type="text" class="form-control" placeholder="Specification" v-model="search.specification">
        <label for="example-text-input" class="form-control-label mt-3">Size</label>
        <input type="text" class="form-control" placeholder="Size" v-model="search.size">
        <label for="example-text-input" class="form-control-label mt-3">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="search.type">
          <option value="Consumable">Consumable</option>
          <option value="Welding Rod">Welding Rod</option>
          <option value="Sparepart">Sparepart</option>
          <option value="Tools">Tools</option>
          <option value="Other">Other</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Unit</label>
        <select class="form-select" aria-label="Default select example" v-model="search.unit">
          <option v-for="(u, k) in tableUom.data" :key="k" :value="u.code">{{ u.name }}</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Storage Location</label>
        <input type="text" class="form-control" placeholder="Storage Location" v-model="search.storage_location">
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="search.date"/>
        <label for="example-text-input" class="form-control-label mt-3">Asset Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.type">
          <option value="Asset">Asset</option>
          <option value="Non Asset">Non Asset</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilter.show = true">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL STOCK CARD ======= -->
  <div class="container">
    <vue-final-modal v-model="formStockCrd.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title"></span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formStockCrd.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <h5 class="text-center font-weight-bold mb-3" style="margin-top: 0px;">STOCK CARD</h5>
        <div class="float-end">
         <!--  <a style="margin-top: -40px;" class="btn btn-xs btn-warning d-none d-md-block" :href="apiUrl+'print-pdf/surat-barang-keluar?no_sj='+dataBarangMasuk.no_sj+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a> -->
        </div><hr>
        <div class="row mt-4">
          <div class="col">
            <!-- ==================== HEADER ==================== -->
            <div class="row">
              <div class="col-6">
                <p style="margin-top: 0px;">
                  ITEM CODE : <input style="border: 1px solid black;" v-model="dataStockCard.material_code" size="30" @keyup="getStockCard(dataStockCard.material_code)"><br>
                  ITEM NAME : <span class="text-uppercase">{{ dataStockCard.material_name }}</span>
                </p>
              </div>
              <div class="col-6">
                PERIODE : <flat-pickr :config="{ mode: 'range',}" class="form-control" v-model="searchPeriodeSc" @change="getStockCard(dataStockCard.material_code)"/>
              </div>
            </div><hr>
            <!-- ============== TEBEL Item ITEM ============== -->
            <div class="table-responsive p-0 scroll">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">NO</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">DESCRIPTION</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">DATE</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">STOCK IN</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ISSUED</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">WO NO.</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">ENDING STOCK</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(card, j) in tableStockCard.data" :key="j" @click="setBg(j)" :style="(backgroundRed == j) ? 'background-color: #7FFF00; cursor: pointer;' : 'cursor: pointer;' ">
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{ j + 1 }}</span>
                      </td>
                      <td class="align-middle text-left">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="card.source == 'begining_stock'">BEGINING STOCK {{ moment(card.date).locale('id').format('LL') }} </span>
                        <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="card.source == 'barang_masuk'">RECEIVED {{ card.description }}</span>
                        <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="card.source == 'barang_keluar'">ISSUED TO {{ card.description }}</span>
                      </td>
                      <td class="align-middle text-left">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ moment(card.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="card.status == 'plus'"> {{ card.qty }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="card.status == 'minus'"> {{ card.qty }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase" v-if="card.source == 'barang_keluar'">{{ card.wo_code }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold text-uppercase">{{ card.jumlah_total }}</span>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div><hr>
            <div class="text-center mt-5">
              <!-- <div class="">
                <argon-button color="success" variant="gradient" size="xs mb-4" width="1" @click="generateSJNo(), dataBarangMasuk = {}, formStockCrd.show = false"> <span style="margin-left: 400px; margin-right: 400px;"><i class="fa fa-check" aria-hidden="true"></i> Finished</span></argon-button>
              </div> -->
            </div>

          </div>
        </div>
      </div>
    </vue-final-modal>
  </div>

</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import Multiselect from 'vue-multiselect'
import 'vue3-toastify/dist/index.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import stockBarang from '@/services/stockBarang.service';
import barangMasuk from '@/services/barangMasuk.service';
import akun from '@/services/akun.service';
import materialGroupPR from '@/services/procurement/materialGroupPR.service';
import itemCategory from '@/services/procurement/itemCategory.service';
import itemSubCategory from '@/services/procurement/itemSubCategory.service';
import unitOfMeasurement from '@/services/unitOfMeasurement.service';

export default {
  name: "tables",
  components: {
    Card,
    ArgonButton,
    VueFinalModal,
    BasePagination,
    Multiselect,
    flatPickr,
  },
  data() {
    return {
      moment:moment,
      pagination: {
        page_count: '',
        page: 1,
      },
      table: {
        data: []
      },
      tableStockCard: {
        data: []
      },
      tableItemGroup: {
        data: []
      },
      tableUom: {
        data: []
      },
      tableItemCategory: {
        data: []
      },
      tableItemSubCategory: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formStockCrd: {
        add: true,
        title: "Add Data",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      onLoading: false,
      storageUrl : config.storageUrl,
      dataBarangMasuk: {},
      search: {
        material_code: '',
        material_name: '',
        specification: '',
        size: '',
        type: '',
        unit: '',
        storage_location: '',
        date: '',
        sort_by: 'material_name'
      },
      apiUrl :config.apiUrl,
      role: '',
      backgroundRed: null,

      totalItem: '',
      totalBarang: '',
      totalBarangMasuk: '',
      totalBarangKeluar: '',

      dataStockCard: {},
      searchPeriodeSc: '',

      beginingStockFilter: '',
      afterStockFilter: '',
    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
    this.getRole();
    this.getUom();
  },
  methods: {
    getUom(){
      let context = this;
      Api(context, unitOfMeasurement.index()).onSuccess(function(response) {
          context.tableUom.data = response.data.data.data;
      }).onError(function(error) {
          if (error.response.status == 404) {
              context.tableUom.data = [];
          }
      })
      .call()
    },
    get(param){
      let context = this;               
      Api(context, stockBarang.index({material_code: context.search.material_code, material_name: context.search.material_name, specification: context.search.specification, size: context.search.size, type: context.search.type, unit: context.search.unit, storage_location: context.search.storage_location, date: context.search.date, sort_by: context.search.sort_by, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          context.totalItem         = response.data.data.totalItem;
          context.totalBarang       = response.data.data.totalBarang;
          context.totalBarangMasuk  = response.data.data.totalBarangMasuk;
          context.totalBarangKeluar = response.data.data.totalBarangKeluar;

          context.beginingStockFilter = response.data.data.beginingStockFilter
          context.afterStockFilter    = response.data.data.afterStockFilter

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    getStockCard(item_code) {
      let context = this;    

      this.formStockCrd.show = 'true';         
      Api(context, stockBarang.getStockCard({item_code: item_code, periode: this.searchPeriodeSc})).onSuccess(function(response) {
          context.dataStockCard  = response.data.data.data;
          context.tableStockCard.data = response.data.data.stockCrd;
      })
      .call()        
    },
    getRole(){
      let context = this;     
      context.onLoading = true;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
      }).onError(function(error) {  
      })
      .call() 
    },
    getItemGroup(param){
      let context = this;        
      Api(context, materialGroupPR.getMaterialGroupPR({search: param.target.value})).onSuccess(function(response) {    
          context.tableItemGroup.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableItemGroup.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    nameWithGrpCode ({ material_group_code, group_name }) {
      return `${material_group_code} - ${group_name}`
    },
    getItemCategory(param){
      let context = this;        
      Api(context, itemCategory.getMaterialCategoryPR({search: param.target.value})).onSuccess(function(response) {    
          context.tableItemCategory.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableItemCategory.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    nameWithCatCode ({ category_code, category_name }) {
      return `${category_code} - ${category_name}`
    },
    getItemSubCategory(param){
      let context = this;        
      Api(context, itemSubCategory.getSubCategory({search: param.target.value})).onSuccess(function(response) {    
          context.tableItemSubCategory.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableItemSubCategory.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    nameWithSubCode ({ sub_category_code, sub_category_name }) {
      return `${sub_category_code} - ${sub_category_name}`
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add   = true;
      this.form.show  = true;
      this.form.title = "Add Data";
      this.dataBarangMasuk   = {};
      // this.defaultDate()
    },
    edit(id) {
      let context = this;               
      Api(context, stockBarang.show(id)).onSuccess(function(response) {
          context.dataBarangMasuk                   = response.data.data.data;
          context.dataBarangMasuk.qty_old           = response.data.data.qty;
          context.dataBarangMasuk.item_group        = response.data.data.dataItemGroup;
          context.dataBarangMasuk.item_category     = response.data.data.dataItemCategory;
          context.dataBarangMasuk.item_sub_category = response.data.data.dataItemSubCategory;
          context.form.show                         = true;
          context.form.title                        = 'Edit Data';      
      })
      .call()        
    },
    filesChange(e) {
      this.dataBarangMasuk.image = e.target.files[0];
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.dataBarangMasuk.material_name != undefined && context.dataBarangMasuk.unit != undefined) {
        formData.append('material_code', context.dataBarangMasuk.material_code);
        formData.append('material_name', context.dataBarangMasuk.material_name);
        formData.append('type', context.dataBarangMasuk.type);
        formData.append('unit', context.dataBarangMasuk.unit);
        formData.append('stock_barang', context.dataBarangMasuk.stock_barang);
        // if (context.form.title == 'Add Data') {
        //   formData.append('stock_barang', (context.dataBarangMasuk.qty + ((context.dataBarangMasuk.stock_barang == undefined) ? 0 : context.dataBarangMasuk.stock_barang) ));
        // }else{
        //   formData.append('stock_barang', ((context.dataBarangMasuk.stock_barang - context.dataBarangMasuk.qty_old) + context.dataBarangMasuk.qty) );
        // }
        formData.append('min_stock', context.dataBarangMasuk.min_stock);
        formData.append('storage_location', context.dataBarangMasuk.storage_location);
        formData.append('specification', (this.dataBarangMasuk.specification == undefined) ? '' : this.dataBarangMasuk.specification);
        formData.append('size', (this.dataBarangMasuk.size == undefined) ? '' : this.dataBarangMasuk.size);
        formData.append('image', (this.dataBarangMasuk.image == undefined) ? '' : this.dataBarangMasuk.image);
        formData.append('note', (this.dataBarangMasuk.note == undefined) ? '' : this.dataBarangMasuk.note);
        formData.append('item_group', JSON.stringify(context.dataBarangMasuk.item_group));
        formData.append('item_category', (JSON.stringify(context.dataBarangMasuk.item_category) == undefined) ? '' : JSON.stringify(context.dataBarangMasuk.item_category));
        formData.append('item_sub_category', (JSON.stringify(context.dataBarangMasuk.item_sub_category) == undefined) ? '' : JSON.stringify(context.dataBarangMasuk.item_sub_category));
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, stockBarang.create(formData));
      } else {
          api = Api(context, stockBarang.update(this.dataBarangMasuk.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;

        Api(context, stockBarang.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    cutOff(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      formData.append('date', '');

      api = Api(context, stockBarang.cutOff(formData));

      api.onSuccess(function(response) {
        context.get();
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    defaultDate(){
      var date  = new Date();
      var day   = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var today = date.getFullYear() + "-" + (month) + "-" + (day);

      this.dataBarangMasuk.date = today
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    setBg(id) {
      this.backgroundRed = id
    },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.scroll { 
  overflow: auto; 
  height: 600px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
</style>
